(() => {
  if (window.__noirCollectionRatingObserver) return;

  const sync = () => {
    document.querySelectorAll('.noir-collection product-block.product-block--compact-rating, .noir-product-showcase product-block.product-block--compact-rating, .navigation__mobile-products product-block.product-block--compact-rating').forEach((card) => {
      const source = card.querySelector('.collection-icon-list.vstar-star[data-review-num][rating]');
      const badge = card.querySelector('[data-noir-card-rating]');
      if (!source || !badge) return;

      const count = Number.parseInt(source.getAttribute('data-review-num'), 10);
      const rating = Number.parseFloat(source.getAttribute('rating'));
      if (!Number.isFinite(count) || count < 1 || !Number.isFinite(rating) || rating < 0 || rating > 5) return;

      const score = rating.toFixed(1);
      const fullCount = (badge.dataset.countLabel || '__COUNT__ reviews').replace('__COUNT__', String(count));
      const ratingLabel = (badge.dataset.ratingLabel || '__RATING__ / 5').replace('__RATING__', score);
      const label = `${ratingLabel}. ${fullCount}`;
      const scoreNode = badge.querySelector('.noir-card-rating__score');
      const fullNode = badge.querySelector('.noir-card-rating__full');
      const shortNode = badge.querySelector('.noir-card-rating__short');
      if (scoreNode && scoreNode.textContent !== score) scoreNode.textContent = score;
      if (fullNode && fullNode.textContent !== fullCount) fullNode.textContent = fullCount;
      if (shortNode && shortNode.textContent !== String(count)) shortNode.textContent = String(count);
      if (badge.getAttribute('aria-label') !== label) badge.setAttribute('aria-label', label);
      if (badge.hidden) badge.hidden = false;
    });
  };

  let pending = false;
  const schedule = () => {
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => { pending = false; sync(); });
  };

  sync();
  window.__noirCollectionRatingObserver = new MutationObserver(schedule);
  window.__noirCollectionRatingObserver.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['data-review-num', 'rating']
  });
})();
